import client from './client';

export const sonarqubeApi = {
  async getProjectData(projectKey) {
    const { data } = await client.get(`/api/projects/${projectKey}/sonarqube`);
    return data;
  },

  async refresh(projectKey) {
    const { data } = await client.get(`/api/projects/${projectKey}/sonarqube/refresh`);
    return data;
  },

  async getIssues(projectKey, params = {}) {
    const { data } = await client.get(`/api/projects/${projectKey}/sonarqube/issues`, { params });
    return data;
  },

  async getProjects() {
    const { data } = await client.get('/api/profile/sonarqube-projects');
    return data.projects;
  },
};
